/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
export type GQLAgentAccountProfileUserFieldsFragment = {
	__typename: "IdentityUser";
	id: string;
	firstName: string | null;
	lastName: string | null;
	displayName: string | null;
	email: string | null;
	phoneNumber: string | null;
	personalEmail: string | null;
	address: {
		__typename: "IdentityAddress";
		street1: string | null;
		street2: string | null;
		city: string | null;
		state: string | null;
		postalCode: string | null;
		id: string;
	} | null;
	phoneNumbers: Array<{
		__typename: "IdentityContact";
		id: string;
		value: string;
		type: Types.GQLIdentityContactType | null;
		isPrimary: boolean;
	} | null> | null;
};

export type GQLAgentAccountProfileMemberFieldsFragment = {
	__typename: "IdentityTeamMember";
	id: string;
	user: {
		__typename: "IdentityUser";
		id: string;
		firstName: string | null;
		lastName: string | null;
		displayName: string | null;
		email: string | null;
		phoneNumber: string | null;
		personalEmail: string | null;
		address: {
			__typename: "IdentityAddress";
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			postalCode: string | null;
			id: string;
		} | null;
		phoneNumbers: Array<{
			__typename: "IdentityContact";
			id: string;
			value: string;
			type: Types.GQLIdentityContactType | null;
			isPrimary: boolean;
		} | null> | null;
	};
	license: {
		__typename: "IdentityLicense";
		id: string;
		number: string | null;
	} | null;
};

export const AgentAccountProfileUserFieldsFragmentDoc = gql`
    fragment AgentAccountProfileUserFields on IdentityUser {
  id
  firstName
  lastName
  displayName
  address {
    street1
    street2
    city
    state
    postalCode
    id
  }
  email
  phoneNumber
  phoneNumbers {
    id
    value
    type
    isPrimary
  }
  personalEmail
}
    `;
export const AgentAccountProfileMemberFieldsFragmentDoc = gql`
    fragment AgentAccountProfileMemberFields on IdentityTeamMember {
  id
  user {
    ...AgentAccountProfileUserFields
  }
  license {
    id
    number
  }
}
    ${AgentAccountProfileUserFieldsFragmentDoc}`;
